export default __webpack_public_path__ + "static/media/f104529d52673435753443984d0124841576250835401.90df903b.webp";